module.exports = __webpack_public_path__ + "img/openFooter.ca8f9a4b.png";